const routers = [
    {
        path: '/',
        meta: {
            title: ''
        },
        component: (resolve) => require(['./views/index.vue'], resolve)
    },
    {
        path: '/servicios',
        name: 'servicios',
        meta: {
            title: 'Servicios'
        },
        component: (resolve) => require(['./views/servicios.vue'], resolve)
    },
    {
        path: '/servicios2',
        name: 'servicios2',
        meta: {
            title: 'Servicios paso2'
        },
        component: (resolve) => require(['./views/servicios2.vue'], resolve)
    },
    {
        path: '/servicios3',
        name: 'servicios3',
        meta: {
            title: 'Servicios paso3'
        },
        component: (resolve) => require(['./views/servicios3.vue'], resolve)
    },

    {
        path: '/zonasocios',
        name: 'zonasocios',
        meta: {
            title: 'Zona Socios'
        },
        component: (resolve) => require(['./views/zonasocios.vue'], resolve)
    },

    {
        path: '/zonaclientes',
        name: 'zonaclientes',
        meta: {
            title: 'Zona Clientes'
        },
        component: (resolve) => require(['./views/zonaclientes.vue'], resolve)
    },

    {
        path: '/ser-socio',
        name: 'registro',
        props: true,
        meta: {
            title: 'Registro de Nuevo Cliente'
        },
        component: (resolve) => require(['./views/registro.vue'], resolve)
    },
    {
        path: '/registroOK',
        name: 'registroOK',
        props: true,
        meta: {
            title: 'Registro correcto'
        },
        component: (resolve) => require(['./views/registroOK.vue'], resolve)
    },
    {
        path: '/registroKO',
        name: 'registroKO',
        props: true,
        meta: {
            title: 'Registro incorrecto'
        },
        component: (resolve) => require(['./views/registroKO.vue'], resolve)
    },

    {
        path: '/formulario-de-contacto',
        name: 'contactamos',
        props: true,
        meta: {
            title: 'Contactamos'
        },
        component: (resolve) => require(['./views/contactamos.vue'], resolve)
    },

    {
        path: '/profesionales',
        name: 'profesionales',
        props: true,
        meta: {
            title: 'Profesionales'
        },
        component: (resolve) => require(['./views/profesionales.vue'], resolve)
    },

    {
        path: '/empleo-y-practicas',
        name: 'empleados',
        props: true,
        meta: {
            title: 'Empleados'
        },
        component: (resolve) => require(['./views/empleados.vue'], resolve)
    },

    {
        path: '/transok',
        name: 'transok',
        props: true,
        meta: {
            title: 'Transacción Correcta'
        },
        component: (resolve) => require(['./views/transok.vue'], resolve)
    },

    {
        path: '/transko',
        name: 'transko',
        props: true,
        meta: {
            title: 'Transacción Incorrecta'
        },
        component: (resolve) => require(['./views/transko.vue'], resolve)
    },


    {
        path: '/ayuda',
        name: 'ayuda',
        props: true,
        meta: {
            title: 'Ayuda'
        },
        component: (resolve) => require(['./views/ayuda.vue'], resolve)
    },

    {
        path: '/sobre-nosotros',
        name: 'nosotros',
        props: true,
        meta: {
            title: 'Sobre Nosotros'
        },
        component: (resolve) => require(['./views/nosotros.vue'], resolve)
    },

    {
        path: '/preguntas-frecuentes',
        name: 'preguntas',
        props: true,
        meta: {
            title: 'Preguntas Frecuentes'
        },
        component: (resolve) => require(['./views/preguntas.vue'], resolve)
    },
    {
        path: '/aviso-legal',
        name: 'legal',
        props: true,
        meta: {
            title: 'Aviso Legal'
        },
        component: (resolve) => require(['./views/legal.vue'], resolve)
    },
    {
        path: '/politica-de-privacidad',
        name: 'privacidad',
        props: true,
        meta: {
            title: 'Política de Privacidad'
        },
        component: (resolve) => require(['./views/privacidad.vue'], resolve)
    },
    {
        path: '/politica-de-cookies',
        name: 'cookies',
        props: true,
        meta: {
            title: 'Política de Cookies'
        },
        component: (resolve) => require(['./views/cookies.vue'], resolve)
    },
    {
        path: '/oficinas-y-servicio-24h',
        name: 'oficinas',
        props: true,
        meta: {
            title: 'Oficinas y servicio 24h'
        },
        component: (resolve) => require(['./views/oficinas.vue'], resolve)
    },
    {
        path: '/servicios-sector',
        name: 'serviciossec',
        props: true,
        meta: {
            title: 'Servicios Sector'
        },
        component: (resolve) => require(['./views/serv-fami.vue'], resolve)
    },
    {
        path: '/confirmacion',
        name: 'confirmacion',
        props: true,
        meta: {
            title: 'Confirmación'
        },
        component: (resolve) => require(['./views/confirma.vue'], resolve)
    },
    {
        path: '/confirmacion1',
        name: 'confirmacion1',
        props: true,
        meta: {
            title: 'Confirmación1'
        },
        component: (resolve) => require(['./views/confirma1.vue'], resolve)
    },
    {
        path: '/confirmacion2',
        name: 'confirmacion2',
        props: true,
        meta: {
            title: 'Confirmación2'
        },
        component: (resolve) => require(['./views/confirma2.vue'], resolve)
    },



	{
        path: '*',
        redirect: '/'
    }    
];
export default routers;


// WEBPACK FOOTER //
// ./src/router.js